import { createContext, HTMLAttributes } from 'react';

export interface FilterContextProps<S, F> extends HTMLAttributes<HTMLDivElement>{
    title: string;
    sort?: S;
    setSort?: (sort: S) => void;
    sortItems?: {value: S, label: string}[];
    filters?: F[];
    setFilters?: (filters: F[]) => void;
    filterItems?: {value: F, label: string}[];
    isOpen: boolean;
    setIsOpen: (b: boolean) => void;
}

const FilterContext = createContext<FilterContextProps<any, any>>({} as FilterContextProps<any, any>);

export default FilterContext;
